export default __webpack_public_path__ + "media/images/signup-bg-f62732dd033848710e1184443a5e26a7.jpg";